module.exports = __webpack_public_path__ + "static/mtb-logo-dd-20312e8e5ad3f1d2491f94f2d0f867f6.png";